import React, { useState,useEffect} from 'react';
import { Button } from 'react-bootstrap';
import BomDatatable from './BomDatatable';
import BomModal from './BomModal';



const BomListTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
    const [checkTime, setCheckTime] = useState(null);

    const handleCallback = (id) => {      
      if(id!==''){
        props.parentCallback(id,'DETAIL');
      }else{
        modalCallback(true,id);
      }
    };
 
    const modalCallback = (show,id) => {             
        setRecordId(id);  
        setShow(show);           
    }

    useEffect(() => {      
      setCheckTime(Date.now());
    }, [props.isActive])

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <BomDatatable            
            parentCallback={handleCallback}  
            modalCallback={modalCallback}  
            modalShow={show}    
            checkTime={checkTime}                            
          />
         
          <BomModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}                      
          />
         
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} 
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default BomListTab;